
































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import FeedbackForm from "./FeedbackForm.vue";
import * as api from "../api";
import dataURItoBlob from "../helpers/dataURItoBlob";
import { html2canvas } from "../html2canvas";

@Component({
  components: { FeedbackForm }
})
export default class Modal extends Vue {
  @Prop({ required: true })
  value!: boolean;
  @Prop({ required: true })
  type!: api.Type;

  visibleState = false;
  dataURI = "";
  feedbackId = 0;
  descriptionToken = "";

  get title(): string {
    return this.type === api.Type.Like
      ? this.$t("feedback.texts.postitiveTitle").toString()
      : this.$t("feedback.texts.negativeTitle").toString();
  }

  get subtitle(): string {
    return this.type === api.Type.Like
      ? this.$t("feedback.texts.postitiveSubtitle").toString()
      : this.$t("feedback.texts.negativeSubtitle").toString();
  }

  @Watch("value")
  async onValue(val: boolean, oldVal: boolean) {
    if (val === oldVal) return;
    if (!val) {
      this.feedbackId = 0;
      this.descriptionToken = "";
      this.visibleState = val;
      return;
    }
    this.dataURI = await this.takeScreenshot();

    try {
      const data = await api.postInitialFeedback(this.type);
      this.feedbackId = data.id;
      this.descriptionToken = data.description_token;
      api.postScreenshot(
        data.screenshot_token,
        this.feedbackId,
        dataURItoBlob(this.dataURI)
      );
    } catch (e) {
      //
    }
    this.visibleState = val;
  }

  get visible(): boolean {
    return this.visibleState;
  }
  set visible(val: boolean) {
    this.$emit("input", val);
  }

  takeScreenshot(): Promise<string> {
    return new Promise<string>(resolve => {
      html2canvas(document.body, {
        allowTaint: true
      }).then(canvas => {
        resolve(canvas.toDataURL());
      });
    });
  }
}
